import {useState,useEffect} from 'react'
import {KTCard, KTCardBody} from '../../_metronic/helpers'
import searchicon from '../../_metronic/images/hd_search.svg'
import {UsersListPagination} from '../modules/apps/user-management/users-list/components/pagination/UsersListPagination'
import {Spinner} from 'react-bootstrap'

interface filterOptions{
  searchText?:string
  perPage?:number
  page?:number
}

export default function SearchListOld({
  listCount = 0,
  children,
  paginatedCount=0,
  selectedCount=0,
  filterOptions,
  setFilterOptions,
  listLoading,
  toolbar,
  isSearchable = true,
}: any) {
  const [page, updatePage] = useState<any>(0)
  const updateRowsPerPage = (value: number) => {
    setFilterOptions((prevOptions: filterOptions) => {
      return {...prevOptions, perPage: value, page: 1}
    })
  }
  useEffect(()=>{
    setFilterOptions((prevOptions: filterOptions) => {
      return {...prevOptions, page: page+1}
    })
  },[page])
  return (
    <KTCard>
      <div className='card card-custom'>
            <div className='card-header card-body pb-0 border-0'>
          <div className='card-title'>
            {isSearchable && (
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  type='text'
                  data-kt-ecommerce-order-filter='search'
                  className='form-control form-control-solid w-250px pe-14'
                  placeholder='Search'
                  onChange={(e) =>
                    setFilterOptions((prev: filterOptions) => {
                      updatePage(0)
                      return {...prev, searchText: e.target.value, page: page + 1}
                    })
                  }
                />
                <span className='svg-icon svg-icon-1 position-absolute me-4' style={{right: 0}}>
                  <img src={searchicon} alt='search' />
                </span>
              </div>
            )}
            {!isSearchable&&(
              selectedCount>0?(<div className='fs-6 fw-bold text-black'>{`${selectedCount} Report(s) Selected`}</div>):(<div className='fs-6 fw-bold text-black'>{`Showing ${paginatedCount} of ${listCount} Reports`}</div>)
              
            )}
          </div>

          <div className='card-toolbar flex-row-fluid justify-content-end gap-5'>{toolbar}</div>
        </div>
          
        
        
        <KTCardBody className='pe-0 py-0 min-h-400px' scroll>
          {listLoading ? (
            <div className='text-center'>
              <Spinner animation='border' className='text-gray-600' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </Spinner>
            </div>
          ) : listCount !== 0 ? (
            children
          ) : (
            <div className='fs-4 fw-semibold text-center text-muted min-h-400px d-flex-align-items-center justify-content-center'>
              <div>No Results Found</div>
            </div>
          )}
        </KTCardBody>
        {listCount > 0 ? (
          <div className='card-footer border-0'>
            <UsersListPagination
              page={page}
              total={listCount}
              updatePage={updatePage}
              recordsPerPage={(e: any) => {
                updateRowsPerPage(parseInt(e))
              }}
              rowsPerPage={filterOptions.perPage}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </KTCard>
  )
}
